/**
 * D-140 (2026-05-20) — Sentry client config pro POS React (Vite).
 *
 * Captura erros JS no browser do caixa/atendente. Inicializado em main.tsx
 * ANTES do render do <App/>.
 *
 * Filtros específicos do POS:
 *  - Balança desconectada não é erro (é o estado padrão entre pesagens)
 *  - Impressora offline é tratada via UI — não notifica
 *  - AbortError de fetch cancelado quando user navega rápido
 */
import * as Sentry from '@sentry/react'

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined
  if (!dsn) {
    console.log('[Sentry] VITE_SENTRY_DSN ausente — desligado.')
    return
  }
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    // Liga só em produção
    enabled: import.meta.env.PROD,
    tracesSampleRate: 0.05,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    ignoreErrors: [
      // Fetch cancelado quando user muda de tela
      'AbortError',
      'cancelled',
      // Balança offline é normal
      /balança.*desconectada/i,
      /scanner.*not.*found/i,
      // Camera permission negada (user fala "não" no prompt)
      'Permission denied',
      'NotAllowedError',
      // ResizeObserver é warning conhecido do Chrome
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
    ],
    denyUrls: [
      /extensions\//i,
      /^chrome:\/\//i,
      /^moz-extension:\/\//i,
    ],
    beforeSend(event) {
      if (event.request?.url) {
        event.request.url = event.request.url
          .replace(/([?&])(senha|password|pin|token|cpf)=[^&]*/gi, '$1$2=[REDACTED]')
      }
      return event
    },
  })
  console.log('[Sentry] inicializado · mode=' + import.meta.env.MODE)
}
